import script from "./referrals.vue?vue&type=script&setup=true&lang=js"
export * from "./referrals.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__